import { render, staticRenderFns } from "./BillCanvas.vue?vue&type=template&id=d3b987b6&scoped=true"
import script from "./BillCanvas.vue?vue&type=script&lang=js"
export * from "./BillCanvas.vue?vue&type=script&lang=js"
import style0 from "./BillCanvas.vue?vue&type=style&index=0&id=d3b987b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3b987b6",
  null
  
)

export default component.exports